export default __webpack_public_path__ + "static/s13-93df72687e73aef8971bec3efe212cf9.jpg";